// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#policy-container[data-v-1618b608] {\n  padding: 0 24px 0 24px;\n}\n\n", ""]);
// Exports
module.exports = exports;
